var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 52,
    viewBox: "0 0 149 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M123.123 2.82764H25.8775C13.1334 2.82764 2.80237 13.2023 2.80237 26C2.80237 38.7978 13.1334 49.1725 25.8775 49.1725H123.123C135.867 49.1725 146.198 38.7978 146.198 26C146.198 13.2023 135.867 2.82764 123.123 2.82764Z",
    fill: "url(#paint0_linear_99_1267)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M123.123 2.82764H25.8775C13.1334 2.82764 2.80237 13.2023 2.80237 26C2.80237 38.7978 13.1334 49.1725 25.8775 49.1725H123.123C135.867 49.1725 146.198 38.7978 146.198 26C146.198 13.2023 135.867 2.82764 123.123 2.82764Z",
    stroke: "url(#paint1_linear_99_1267)",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M54.5949 26.9083L55.4478 30.4487L58.49 30.3059L55.8174 32.3046L59.5704 35.3882L53.3154 35.5024L54.0831 39.2426L78.9894 38.4432L78.3923 35.017L72.6206 35.1312L76.0609 31.5908L72.8765 29.5636L77.5109 29.3352L76.6864 26.1945L68.1284 26.48L68.1568 24.0246L73.8148 23.739L73.4736 22.34C74.4971 22.8825 75.5775 23.3964 76.6864 23.9389L79.2452 20.4556C74.8667 18.8567 71.3981 17.2578 67.8441 15.2877L68.7823 14.317L65.1715 13.4033C61.4754 16.5155 58.1773 18.7139 52.8036 21.769L55.6753 25.0239L58.4616 23.1395L58.7743 24.5099L63.8068 24.253L63.8352 26.6228L54.5949 26.9083ZM68.0715 29.8206L72.5638 29.5921L69.4078 33.9606L71.2843 35.1597L67.9578 35.2168L68.0715 29.8206ZM65.4842 17.5433C66.9627 18.5712 68.5833 19.599 70.3461 20.6269L61.5891 20.8268C62.9822 19.7704 64.2332 18.6854 65.4842 17.5433ZM62.8117 33.9891L59.542 30.2488L63.8921 30.0204L63.9774 35.3025L61.0773 35.3596L62.8117 33.9891ZM83.1054 24.7384L83.674 27.7363L87.6545 27.565C87.5692 27.7648 87.4554 27.8505 87.3417 28.0504L80.774 28.3073L81.5132 31.3624L85.124 31.191C83.9583 32.6472 82.622 34.189 80.9161 36.0448L83.5603 39.157C84.925 37.5866 86.1191 36.3018 87.1427 34.9599L89.531 34.8457L88.479 35.3596L90.981 38.5003L94.3359 36.0734L92.3457 34.7029L98.0036 34.4459L98.0321 36.3589L94.7624 36.5017V38.6145L101.7 39.8422L101.842 34.2746L106.107 34.0748L105.083 31.448L101.927 31.5622L101.956 30.3059L106.164 30.0775L105.595 27.3366L91.6918 27.879C91.7771 27.6792 91.8908 27.5364 91.9761 27.3366L103.804 26.7655L103.264 24.1673L93.2555 24.4528L93.483 23.9104L105.254 23.5963L104.571 20.5413L94.6203 20.9695L94.8477 20.3414L91.5781 19.4277C91.5496 19.4563 91.5496 19.4848 91.5496 19.5134L90.5261 18.2286L93.5114 17.8574L92.5163 19.285L96.4683 20.0559L97.3781 18.5712L98.7997 18.3999L99.937 20.1701L103.889 19.599L102.382 17.9716L106.306 17.4862L105.225 14.7738L99.2262 15.2021L99.9086 13.7174L96.2124 13.4319C95.5585 14.7167 94.8193 15.973 93.8242 17.4291L92.9143 15.0879L87.5407 15.459L88.2515 14.0315L84.6123 13.489C83.5887 15.4305 82.2808 17.629 80.4896 20.1415L84.3848 21.255C84.925 20.3699 85.3799 19.599 85.8064 18.8281L86.8584 18.6854L87.6829 20.3699L91.3506 19.9702L90.8673 21.1408L81.4563 21.5406L82.1103 24.1959L89.5594 23.996L89.3035 24.567L83.1054 24.7384ZM97.9183 30.5058L97.9468 31.6764L89.3604 31.9048C89.5878 31.5908 89.7868 31.2481 89.9859 30.9341L97.9183 30.5058ZM107.863 15.9159L109.029 19.5705L111.388 19.2564C110.365 22.2258 109.057 25.0239 107.237 28.3073L109.142 32.1904L109.995 30.7057L110.081 37.7294L118.354 37.3868L118.411 22.7397L113.492 23.3108C114.146 21.6833 114.743 20.1415 115.17 18.771L119.15 18.2286L118.383 15.1164L107.863 15.9159ZM124.439 19.6276L120.97 19.7133L119.861 28.8784L129.329 28.3073L129.244 35.3882L124.183 35.3596L124.211 37.5866L132.542 39.7851L133.338 24.7955L130.807 24.9097L132.03 14.7167L118.923 15.4305L119.946 18.771L128.22 18.1144L127.225 25.081L123.842 25.2237L124.439 19.6276ZM118.894 31.2481L119.776 34.5887L129.045 33.3895L128.732 30.5344L118.894 31.2481ZM113.464 34.3603L113.549 26.5942L115.028 26.1659L115.141 34.1033L113.464 34.3603Z",
    fill: "url(#paint2_linear_99_1267)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M53.3587 25.6668L54.2117 29.2072L57.2539 29.0645L54.5813 31.0631L58.3343 34.1467L52.0793 34.2609L52.8469 38.0012L77.7532 37.2017L77.1561 33.7755L71.3845 33.8897L74.8247 30.3493L71.6404 28.3221L76.2748 28.0937L75.4502 24.953L66.8923 25.2386L66.9207 22.7831L72.5786 22.4976L72.2374 21.0986C73.261 21.641 74.3414 22.155 75.4502 22.6975L78.0091 19.2141C73.6306 17.6152 70.1619 16.0163 66.6079 14.0463L67.5462 13.0755L63.9353 12.1619C60.2392 15.274 56.9411 17.4725 51.5675 20.5275L54.4391 23.7824L57.2254 21.898L57.5382 23.2685L62.5706 23.0115L62.599 25.3813L53.3587 25.6668ZM66.8354 28.5791L71.3276 28.3507L68.1717 32.7191L70.0482 33.9183L66.7217 33.9754L66.8354 28.5791ZM64.2481 16.3019C65.7265 17.3297 67.3472 18.3576 69.1099 19.3855L60.3529 19.5853C61.7461 18.5289 62.9971 17.4439 64.2481 16.3019ZM61.5755 32.7477L58.3058 29.0074L62.6559 28.779L62.7412 34.061L59.8412 34.1181L61.5755 32.7477ZM81.8692 23.4969L82.4379 26.4948L86.4183 26.3235C86.333 26.5234 86.2193 26.609 86.1056 26.8089L79.5378 27.0659L80.277 30.1209L83.8879 29.9496C82.7222 31.4057 81.3859 32.9475 79.68 34.8034L82.3241 37.9155C83.6889 36.3452 84.883 35.0603 85.9065 33.7184L88.2948 33.6042L87.2428 34.1181L89.7448 37.2588L93.0998 34.8319L91.1096 33.4615L96.7675 33.2045L96.7959 35.1175L93.5263 35.2602V37.373L100.464 38.6008L100.606 33.0332L104.871 32.8333L103.847 30.2066L100.691 30.3208L100.72 29.0645L104.927 28.8361L104.359 26.0951L90.4556 26.6376C90.5409 26.4377 90.6547 26.295 90.74 26.0951L102.568 25.5241L102.027 22.9259L92.0194 23.2114L92.2468 22.6689L104.018 22.3548L103.335 19.2998L93.3841 19.7281L93.6116 19.0999L90.3419 18.1863C90.3135 18.2148 90.3135 18.2434 90.3135 18.2719L89.2899 16.9871L92.2753 16.6159L91.2802 18.0435L95.2322 18.8144L96.142 17.3297L97.5636 17.1584L98.7009 18.9286L102.653 18.3576L101.146 16.7301L105.07 16.2448L103.989 13.5323L97.9901 13.9606L98.6724 12.4759L94.9763 12.1904C94.3224 13.4752 93.5831 14.7315 92.588 16.1877L91.6782 13.8464L86.3046 14.2176L87.0154 12.79L83.3761 12.2475C82.3526 14.189 81.0447 16.3875 79.2535 18.9001L83.1487 20.0136C83.6889 19.1285 84.1438 18.3576 84.5702 17.5867L85.6222 17.4439L86.4468 19.1285L90.1145 18.7288L89.6311 19.8994L80.2202 20.2991L80.8741 22.9544L88.3232 22.7546L88.0674 23.3256L81.8692 23.4969ZM96.6822 29.2643L96.7106 30.435L88.1242 30.6634C88.3517 30.3493 88.5507 30.0067 88.7497 29.6926L96.6822 29.2643ZM106.627 14.6744L107.792 18.329L110.152 18.015C109.129 20.9843 107.821 23.7824 106.001 27.0659L107.906 30.9489L108.759 29.4642L108.844 36.4879L117.118 36.1453L117.175 21.4983L112.256 22.0693C112.91 20.4419 113.507 18.9001 113.934 17.5296L117.914 16.9871L117.147 13.875L106.627 14.6744ZM123.202 18.3861L119.734 18.4718L118.625 27.6369L128.093 27.0659L128.007 34.1467L122.947 34.1181L122.975 36.3452L131.306 38.5437L132.102 23.554L129.571 23.6682L130.794 13.4752L117.687 14.189L118.71 17.5296L126.984 16.8729L125.989 23.8395L122.605 23.9823L123.202 18.3861ZM117.658 30.0067L118.54 33.3472L127.808 32.1481L127.496 29.2929L117.658 30.0067ZM112.228 33.1188L112.313 25.3528L113.792 24.9245L113.905 32.8619L112.228 33.1188Z",
    fill: "url(#paint3_radial_99_1267)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_d_99_1267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25.8134 45.0022C36.2464 45.0022 44.7039 36.5075 44.7039 26.0287C44.7039 15.55 36.2464 7.0553 25.8134 7.0553C15.3805 7.0553 6.92291 15.55 6.92291 26.0287C6.92291 36.5075 15.3805 45.0022 25.8134 45.0022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.8134 46.2435C36.9293 46.2435 45.94 37.1929 45.94 26.0288C45.94 14.8647 36.9293 5.81396 25.8134 5.81396C14.6976 5.81396 5.68677 14.8647 5.68677 26.0288C5.68677 37.1929 14.6976 46.2435 25.8134 46.2435Z",
    stroke: "url(#paint4_radial_99_1267)",
    strokeWidth: 6
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M32.0583 8.6207L33.9125 9.44828L34.0924 8.75634C34.4416 7.41354 34.6183 6.03139 34.6183 4.64355C33.9809 6.03058 33.1578 7.32362 32.1718 8.48679L32.0583 8.6207Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter1_d_99_1267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.832 25.9968C44.832 27.7976 44.5757 29.502 44.1278 31.1421C44.0314 26.4791 41.6942 22.4915 38.3324 20.0475C40.0293 20.2083 42.2066 20.7228 43.5513 21.6232C40.2214 17.4426 35.0666 14.8378 30.2959 14.4519C32.249 12.9083 33.4657 11.011 34.106 8.8242C40.4455 11.9114 44.832 18.4395 44.832 25.9968ZM6.92291 25.9968C14.287 43.8445 34.106 32.9751 26.934 25.643C25.8134 25.032 24.4367 24.6461 22.9639 24.4532C19.3138 24.003 15.952 25.0963 18.0331 27.1223C15.984 26.9293 14.255 26.2862 13.1984 24.7104C12.8782 24.9677 12.5581 25.225 12.2378 25.4822C11.6295 22.9095 11.5015 20.3047 15.1515 17.6356C14.1589 20.2726 16.6883 20.1118 19.0256 17.5712C19.4099 17.925 19.9862 18.0536 20.7226 17.8285C20.1142 17.7642 19.666 17.4748 19.4419 17.121C18.8015 16.1884 19.3778 14.5805 21.2029 13.9374C23.7963 13.0048 26.4858 11.5255 27.0941 9.85326C27.5424 10.5286 27.7985 11.3325 27.8946 12.2008C29.6235 11.1074 31.1604 9.75676 32.4731 8.11669C30.392 7.37704 28.1827 6.95898 25.8775 6.95898C15.4076 6.95898 6.92291 15.481 6.92291 25.9968ZM13.4866 22.0413C13.9668 21.2373 15.1195 20.8193 15.1195 21.5589C15.7278 20.0153 14.0309 20.369 13.4866 22.0413ZM21.1388 17.0889C22.7717 16.7673 23.7963 16.0277 24.1805 14.7092C22.6757 15.3202 21.0108 15.6739 21.1388 17.0889Z",
    fill: "url(#paint5_radial_99_1267)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0844 19.8545C25.5573 20.562 26.6779 21.5267 27.4143 22.7166C21.7151 21.173 16.9765 21.8804 13.1984 24.7104C14.255 26.2861 15.984 26.9293 18.0331 27.1223C15.952 25.0963 19.3138 24.0029 22.9639 24.4531C24.4367 24.6461 25.7814 25.032 26.934 25.643C34.106 32.9751 14.287 43.8448 6.92291 25.9967C6.92291 36.5125 15.4076 45.0345 25.8775 45.0345C46.657 45.0345 42.1425 18.6968 24.0844 19.8545Z",
    fill: "url(#paint6_linear_99_1267)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9437 33.4576C31.1604 29.8237 29.6876 27.1223 26.9341 25.6431C34.106 32.9752 14.287 43.8449 6.92291 25.9968C6.92291 30.0488 8.20362 33.8113 10.3488 36.8985C19.5059 50.0191 37.4999 39.021 32.9214 29.8558C32.7293 31.4637 31.1924 32.8144 29.9437 33.4576Z",
    fill: "url(#paint7_linear_99_1267)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0845 19.8544C24.7889 20.176 25.3973 20.5619 25.9415 21.0121C37.0517 21.816 42.4307 34.4543 36.3153 41.497C43.8716 34.39 38.0123 18.954 24.0845 19.8544Z",
    fill: "url(#paint8_linear_99_1267)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1984 24.7103C17.2647 22.2663 22.0354 22.0733 27.5424 24.1636C27.2222 23.5526 26.838 22.9738 26.3577 22.4592C21.1389 21.3015 16.7524 22.0733 13.1984 24.7103Z",
    fill: "url(#paint9_linear_99_1267)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8968 31.946C33.7859 37.6702 25.6854 43.5229 19.666 42.8477C27.9586 43.8448 36.1872 36.416 32.9214 29.8557C32.7613 30.7883 32.5051 31.2707 31.8968 31.946Z",
    fill: "url(#paint10_linear_99_1267)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.934 25.6431C29.1753 27.1545 30.0077 30.2739 28.7591 32.6857C29.3354 32.3963 29.8797 32.0426 30.3599 31.5602C30.5841 28.8911 29.2073 26.8651 26.934 25.6431Z",
    fill: "url(#paint11_linear_99_1267)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7047 10.207L33.0815 9.78894C31.5766 11.9435 29.7836 13.3907 27.6384 14.2268C27.3823 15.2237 26.838 16.1241 26.0375 16.7995C27.7345 16.1563 29.1433 15.3845 30.2639 14.484C32.217 12.9404 33.4336 11.0431 34.074 8.85633C34.4902 7.50567 34.6823 6.02639 34.6823 4.48279C34.3302 5.8656 33.7858 7.15192 33.0174 8.37393C32.6652 9.01713 32.217 9.59599 31.7047 10.207Z",
    fill: "url(#paint12_linear_99_1267)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7047 10.207C33.1455 8.53473 34.1701 6.63741 34.7143 4.48279C34.3622 6.47661 33.5937 8.30963 32.4091 9.98189L31.7047 10.207ZM27.6384 14.1946C27.5424 14.5483 27.4143 14.9021 27.2542 15.2237C30.7442 13.873 32.1529 12.1365 33.4657 9.8854L32.8253 10.1105C31.4165 12.0722 29.6876 13.4228 27.6384 14.1946Z",
    fill: "url(#paint13_linear_99_1267)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8767 19.2756C36.6355 18.1179 34.2982 17.5069 31.8648 17.4747C34.2341 17.7642 36.4434 18.6646 38.3324 20.0474C40.0294 20.2082 42.2066 20.7228 43.5514 21.6232C41.9824 20.3047 40.2535 19.1148 38.2043 18.1501L38.8767 19.2756Z",
    fill: "url(#paint14_linear_99_1267)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3964 19.0505L38.7486 19.5651C37.7881 19.147 36.8276 18.8254 35.835 18.5681C34.5863 17.9893 33.2416 17.6356 31.8648 17.4426C34.1061 17.5069 36.2833 18.0536 38.3964 19.0505ZM38.5245 18.6646C40.4136 19.4686 42.0465 20.4977 43.5514 21.5911C41.9824 20.2726 40.2535 19.0827 38.2043 18.1179L38.5245 18.6646Z",
    fill: "url(#paint15_linear_99_1267)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    opacity: 0.39,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1389 17.0889C23.9244 17.1854 25.2691 15.8669 25.7494 13.7766C25.3332 14.1947 24.7569 14.4841 24.1485 14.7092C23.8283 15.9955 22.7717 16.7673 21.1389 17.0889Z",
    fill: "url(#paint16_linear_99_1267)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    opacity: 0.39,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4866 22.0412C13.9989 20.369 15.6959 20.0152 15.1195 21.5588C16.0801 19.5329 13.8708 19.8223 13.4866 22.0412Z",
    fill: "url(#paint17_linear_99_1267)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_99_1267",
    x: 2.68677,
    y: 2.81396,
    width: 48.2533,
    height: 48.4296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_99_1267"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_99_1267",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_99_1267",
    x: 6.92291,
    y: 6.95898,
    width: 37.9091,
    height: 30.7351,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.72549 0 0 0 0 0.109804 0 0 0 0 0.109804 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_99_1267"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_99_1267",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_1267",
    x1: 136.092,
    y1: 48.3449,
    x2: -45.7323,
    y2: -37.5071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC2626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF4444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_1267",
    x1: 136.092,
    y1: 48.3449,
    x2: 11.4774,
    y2: -2.55919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B91C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC2626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_99_1267",
    x1: 219.71,
    y1: -4.06392,
    x2: 197.932,
    y2: 68.9129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B91C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC2626"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_99_1267",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6283 8.20683) rotate(21.1244) scale(134.909 76.8558)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF3C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328722,
    stopColor: "#FBBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.590493,
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678938,
    stopColor: "#DC2626"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_99_1267",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.0133 3.86198) rotate(49.5343) scale(77.7773 65.6647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FBBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533697,
    stopColor: "#F59E0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671657,
    stopColor: "#EF4444"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_99_1267",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.101647 -8.74223) rotate(47.9015) scale(86.6969 86.6756)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.127561,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325744,
    stopColor: "#FBBF24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743441,
    stopColor: "#DC2626"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_99_1267",
    x1: 52.462,
    y1: -15.4478,
    x2: 14.586,
    y2: 44.8634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_99_1267",
    x1: -38.4941,
    y1: 34.3017,
    x2: 41.0378,
    y2: 34.3017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7001,
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_99_1267",
    x1: 55.454,
    y1: 8.77936,
    x2: 26.8601,
    y2: 33.3836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC2626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_99_1267",
    x1: 47.2417,
    y1: -0.341935,
    x2: 13.9832,
    y2: 30.0654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_99_1267",
    x1: 59.3524,
    y1: 36.409,
    x2: 18.2609,
    y2: 36.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_99_1267",
    x1: 56.8385,
    y1: 29.1839,
    x2: 18.8131,
    y2: 29.1839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_99_1267",
    x1: 28.0721,
    y1: 13.5933,
    x2: 37.4821,
    y2: 4.99765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_99_1267",
    x1: 22.2163,
    y1: 22.2996,
    x2: 37.8078,
    y2: 2.83708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3681,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_99_1267",
    x1: 20.8112,
    y1: 19.5425,
    x2: 45.0508,
    y2: 19.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_99_1267",
    x1: 8.78057,
    y1: 19.5425,
    x2: 48.3106,
    y2: 19.5425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_99_1267",
    x1: 12.4779,
    y1: 15.4339,
    x2: 25.0463,
    y2: 15.4339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_99_1267",
    x1: 17.3876,
    y1: 21.1203,
    x2: 14.2521,
    y2: 21.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF24",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthLogo);
export default __webpack_public_path__ + "static/media/authLogo.98d601108c4c3a4b21c7b07483c2a19e.svg";
export { ForwardRef as ReactComponent };